<template>
    <div id="boxSelezionaFarmaco" class="sa-bancafarmaci sa-bancafarmaci-hidden">
        <div class="sa-flexbox">
            <div class="sa-flexbox-header">
                <b-form @submit.prevent="onClickDescrizioneFarmaco">
                    <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                        <b-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                            <label class="sa-label-data">Nome Commerciale:</label>
                            <b-form-input maxlength="16" class="text-uppercase" v-model="filtroFarmaci.descrizione" :placeholder="this.$i18n.t('therapy.lblDrug')"></b-form-input>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <label class="sa-label-data">Codice A.I.C.:</label>
                            <b-form-input maxlength="16" class="text-uppercase" v-model="filtroFarmaci.codiceProdotto" placeholder="A.I.C."></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                            <b-button type="submit" variant="info"><b-icon icon="search"></b-icon> {{ this.$i18n.t("patients.lblFind") }}</b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </div>
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <b-table id="tabellaFarmaci" :busy="isBusy" :items="itemsFarmaci" :fields="fieldsFarmaci" selectable select-mode="single" @row-selected="onRowSelectedFarmaco" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong style="padding-left: 10px">Caricamento dati in corso...</strong>
                            </div>
                        </template>
                    </b-table>
                </div>
            </div>
            <div class="sa-flexbox-footer">
                <div class="sa-flexbox-footer-bar">
                    <div class="sa-flexbox-footer-bar-separator"></div>
                    <div class="sa-flexbox-footer-bar-element"><b-button size="sm" variant="outline-danger" @click="onClickChiudi()">Annulla Selezione</b-button></div>
                    <div class="sa-flexbox-footer-bar-element"><b-button size="sm" variant="outline-success" @click="onClickConferma()" :disabled="isBusy">Conferma Selezione</b-button></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    data() {
        return {
            pathResourceFarmaci: "/farmaci",
            filtroFarmaci: { descrizione: null, aicCode: null },
            farmacoSelezionato: null,
            schedaFarmaco: null,
            isBusy: false,
            itemsFarmaci: [],
            fieldsFarmaci: [
                {
                    label: "Nome Farmaco",
                    key: "descrizione",
                    sortable: true,
                },
                {
                    label: "A.I.C,",
                    key: "codiceProdotto",
                    sortable: true,
                    thStyle: "width: 7rem",
                },
                {
                    label: "ATC",
                    key: "atcGmp",
                    sortable: true,
                    thStyle: "width: 7rem",
                },
                {
                    label: "Prezzo",
                    key: "euroPrezzo1",
                    sortable: true,
                    thStyle: "width: 7rem",
                    formatter: (value) => value.toLocaleString("it-IT", { style: "currency", currency: "EUR" }),
                    // formatter: function (value) {
                    //     return value;
                    // },
                },
            ],
        };
    },
    methods: {
        onClickDescrizioneFarmaco() {
            let me = this;
            me.ricercaFarmaco();
        },
        onClickAtc() {
            let me = this;
            me.ricercaFarmaco();
        },
        ricercaFarmaco() {
            let me = this;
            me.isBusy = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceFarmaci;
            axios
                .get(link, { params: this.filtroFarmaci })
                .then((response) => {
                    me.itemsFarmaci = response.data.data;
                    me.isBusy = false;
                })
                .catch((error) => {
                    me.itemsFarmaci = [];
                    me.isBusy = false;
                    me.$bvModal
                        .msgBoxOk(error.response.data.messaggio, {
                            title: "ATTENZIONE",
                            size: "sm",
                            okVariant: "outline-danger",
                            headerClass: "sa-msg-header-danger",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                        })
                        .then((value) => {
                            this.boxTwo = value;
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                });
        },
        loadDettaglioFarmaco() {
            let me = this;
            if (me.farmacoSelezionato) {
                UtilityMixin.methods.loadDataResources(me.pathResourceFarmaci + "/" + me.farmacoSelezionato.codiceProdotto, {}, me.loadDettaglioFarmacoSuccess, me.loadDettaglioFarmacoError);
            }
        },
        loadDettaglioFarmacoSuccess(response) {
            this.schedaFarmaco = response.data.data;
            this.$emit("confermaSelezione", this.schedaFarmaco);
            this.isBusy = true;
        },
        loadDettaglioFarmacoError(error) {
            console.log(error);
        },
        onClickChiudi() {
            this.$emit("annullaSelezione");
        },
        onClickConferma() {
            this.isBusy = true;
            this.loadDettaglioFarmaco();
        },
        onRowSelectedFarmaco(item) {
            let me = this;
            console.log(item);
            if (item.length > 0) {
                me.farmacoSelezionato = item[0];
            }
        },
    },
};
</script>

<style></style>
